import { gql } from "@apollo/client";

// The Career Tracks overview for someone who doesn't run the ladder: their
// own roles, and their direct reports'.
export default gql`
  fragment MyCareerOverviewPerson on UserNode {
    id
    name
    avatar
    currentRoles {
      id
      title
      level
      careerTrack {
        id
        title
      }
    }
  }
  query getMyCareerOverview {
    me {
      ...MyCareerOverviewPerson
      directReports {
        edges {
          node {
            ...MyCareerOverviewPerson
          }
        }
      }
    }
  }
`;
